module.exports = __webpack_public_path__ + "src/client/components/LandingPage/img/step2.png";


//////////////////
// WEBPACK FOOTER
// ./src/client/components/LandingPage/img/step2.png
// module id = 487
// module chunks = 0